import { toastr } from "../_components/toastr/toastr";
import { accountService } from "../_services/accounts.service";

export function handleResponse(response: Response) {
    return response.text().then(text => {
        let data;

        try {
            data = text && JSON.parse(text);
        } catch (e) {
            data = text;
        }

        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                accountService.logout();
                //window.location.reload(true);
            }

            return Promise.reject(data);
        }
        return data;
    });
}


//export function handleErrorResponse(err: any) {
//    console.log(err);
//    toastr.error(err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
//}

export function handleErrorResponse(err: any): string {
    const message =
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.Message ||
        err?.message ||
        err?.title ||
        "Something went wrong. Please try again later";

    toastr.error(message);
    return typeof message === "string" ? message : JSON.stringify(message);
}
export function handleErrorResponseAxios(err: any) {
    toastr.error(err.response.data || err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}